import { IFaqItem } from 'shared/types/faq';

export const faqOwnerData: IFaqItem[] = [
  {
    id: 1,
    title: 'Сколько стоит публикация объявления о продаже?',
    label: 'sale_price',
    answer: ``,
  },
  {
    id: 2,
    title: 'Сколько стоит публикация объявления об аренде?',
    label: 'rent_price',
    answer: 'Бесплатно — во всех городах',
  },
  {
    id: 3,
    title: 'Что вообще я могу продать или сдать?',
    label: 'what_sale_rent',
    answer: `Продать можно любую недвижимость: квартиру во вторичке и новостройке, комнату, спальное место, долю в квартире,
    дом, часть дома, коттедж, дачу, таунхаус, участок, гараж. Можно сдавать квартиры и дома в аренду надолго и
    посуточно.`,
  },
  {
    id: 4,
    title: 'Зачем мне размещаться на Циан, если я уже разместился на другой площадке?',
    label: 'why_add_ad',
    answer: `Чтобы продать или сдать недвижимость быстрее и дороже.
    У каждой площадки своя уникальная аудитория. А на Циан
    ищут недвижимость больше 19 млн человек каждый месяц:
    шансы найти того самого покупателя или жильца гораздо выше.`,
  },
  {
    id: 5,
    title: 'Как быстро я могу продать или сдать квартиру?',
    label: 'how_quickly_sale_rent',
    answer: ``,
  },
  {
    id: 6,
    title: 'А могу я продать или сдать коммерческую недвижимость?',
    label: 'commercial_re',
    answer: ``,
  },
  {
    id: 7,
    title: 'Что делать, если я хочу, чтобы ещё больше людей увидели моё объявление?',
    label: 'adv_views',
    answer: ``,
  },
  {
    id: 8,
    title: 'Я боюсь, что мне будут звонить мошенники, что делать?',
    label: 'fraud_calls',
    answer: ``,
  },
];
